import { render } from "./Eventstatisticsmain.vue?vue&type=template&id=e3b5cafc"
import script from "./Eventstatisticsmain.vue?vue&type=script&lang=js"
export * from "./Eventstatisticsmain.vue?vue&type=script&lang=js"

import "./Eventstatisticsmain.vue?vue&type=style&index=0&id=e3b5cafc&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__